import { render, staticRenderFns } from "./dis_entry.vue?vue&type=template&id=06520413&scoped=true&"
import script from "./dis_entry.vue?vue&type=script&lang=js&"
export * from "./dis_entry.vue?vue&type=script&lang=js&"
import style0 from "./dis_entry.vue?vue&type=style&index=0&id=06520413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06520413",
  null
  
)

export default component.exports